import React from 'react';
import 'whatwg-fetch';

import thumbsUpIcon from '../../../images/icons/thumbs-up.svg';

export default class MyToast extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isBlackOut: false,
    };
  }

  render() {
    if (this.props.isOpen === false) return null;

    return (
      <div
        className={
          'myToast ' + (this.props.toastText.success ? 'success ' : 'error ') + (this.props.isAnim ? 'show ' : '')
        }
      >
        <img src={thumbsUpIcon} />
        <span>{this.props.toastText.message}</span>
      </div>
    );
  }

  close(e) {
    e.preventDefault();

    if (this.props.onClose) {
      this.props.onClose();
    }
  }
}
